import "../CSS/skills.css";
import "../App.css";
import React, { useEffect } from "react";
import skill from "../Images/navbar/skills.png";
import reacticon from "../Images/reacticon.png";
import expressicon from "../Images/express.png";
import nodeicon from "../Images/nodejs.png";
import mongodbicon from "../Images/mongodb.png";
import mysqlicon from "../Images/mysql.png";
import htmlicon from "../Images/HTML.png";
import cssicon from "../Images/CSS.png";
import pythonicon from "../Images/python.png";
import scikiticon from "../Images/scikit.png";
import flaskicon from "../Images/flaskicon.png";

function Skills({ setindex }) {
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setindex(2);
        }
      });
    }, options);

    const divs = document.getElementById("skills");
    observer.observe(divs);

    return () => {
      observer.unobserve(divs);
    };
  }, []);
  useEffect(() => {
    const options = {
      root: null, // Use the viewport as the root
      rootMargin: "0px",
      threshold: 0.25,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("skills-contianer-animate");
        } else {
          entry.target.classList.remove("skills-contianer-animate");
        }
      });
    }, options);

    const div1 = document.querySelectorAll(".skills-contianer");
    div1.forEach((item) => {
      observer.observe(item);
    });
    return () => {
      div1.forEach((item) => {
        observer.unobserve(item);
      });
    };
  });
  return (
    <div id="skills" className="skill">
      <div className="header-block fontbold">
        <img src={skill} alt="intro" />
        Skills
      </div>
      <br />
      <br />
      <div id="pageheading" className="namecolor page-heading fontbold">
        Skills
      </div>
      <hr />
      <div className="skills-contianer">
        <div className="skill-item">
          <div>
            <img src={reacticon} alt="react" />
          </div>
          <div>ReactJS</div>
        </div>
        <div className="skill-item">
          <div>
            <img src={expressicon} alt="react" />
          </div>
          <div>Express.js</div>
        </div>
        <div className="skill-item">
          <div>
            <img src={nodeicon} alt="react" />
          </div>
          <div>NodeJS</div>
        </div>
        <div className="skill-item">
          <div>
            <img src={mongodbicon} alt="react" />
          </div>
          <div>MongoDB</div>
        </div>
        <div className="skill-item">
          <div>
            <img src={mysqlicon} alt="react" />
          </div>
          <div>MySQl</div>
        </div>
        <div className="skill-item">
          <div>
            <img src={htmlicon} alt="react" />
          </div>
          <div>HTML5</div>
        </div>
        <div className="skill-item">
          <div>
            <img src={cssicon} alt="react" />
          </div>
          <div>CSS3</div>
        </div>
        <div className="skill-item">
          <div>
            <img src={pythonicon} alt="react" />
          </div>
          <div>Python</div>
        </div>
        <div className="skill-item">
          <div>
            <img src={scikiticon} alt="react" />
          </div>
          <div>SciKit Learn</div>
        </div>
        <div className="skill-item">
          <div>
            <img src={flaskicon} alt="react" />
          </div>
          <div>Flask</div>
        </div>
      </div>
      <br />
      <br />
      <br />
    </div>
  );
}

export default Skills;
